// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","modal":"modal-32Wm1","content":"content-y4h2A","icon":"icon-3m3ci","text":"text-3ZfPO","button":"button-26SK2","no":"no-175pb"};